/**
 * Wraps all occurrences of `query` in `text` with a <mark> tag.
 * Returns empty string for null/undefined input.
 */
export function highlightMatch(text, query) {
    if (!query || !text)
        return text || '';
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    return String(text).replace(regex, '<mark class="search-highlight">$1</mark>');
}
/**
 * Returns true if `matchValue` is already visible in the result's primary display fields,
 * so redundant match annotations can be hidden.
 */
export function isAlreadyVisible(matchValue, result) {
    if (!matchValue)
        return false;
    const val = String(matchValue).toLowerCase();
    const primaryFields = [
        result.name,
        result.orderNum,
        result.accountName,
        result.fullAddress,
        result.accountNumber
    ].map(f => String(f || '').toLowerCase());
    return primaryFields.some(field => field.includes(val));
}
/**
 * Returns true if the item has at least one matchType whose value is not
 * already visible in the primary display fields.
 */
export function hasRelevantMatches(item) {
    if (!item.matchTypes)
        return false;
    return item.matchTypes.some(m => !isAlreadyVisible(m.value, item));
}
